import type { SVGProps } from 'react';
const SvgAiAgentsSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#ai-agents-sidebar_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.88}
        d="M4 6.375a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0m6.286 0a.857.857 0 1 0 1.714 0 .857.857 0 0 0-1.714 0M8 0a8 8 0 1 0 .001 16.001A8 8 0 0 0 8 0m4.696 12.696a6.6 6.6 0 0 1-2.112 1.425A6.6 6.6 0 0 1 8 14.643a6.613 6.613 0 0 1-4.698-1.946A6.606 6.606 0 0 1 1.357 8a6.614 6.614 0 0 1 1.946-4.698A6.606 6.606 0 0 1 8 1.357a6.614 6.614 0 0 1 4.698 1.946A6.605 6.605 0 0 1 14.643 8a6.6 6.6 0 0 1-.52 2.586 6.6 6.6 0 0 1-1.426 2.11m-1.982-4.321h-.859a.144.144 0 0 0-.144.132 1.717 1.717 0 0 1-3.422 0 .144.144 0 0 0-.144-.132h-.86a.143.143 0 0 0-.142.15A2.864 2.864 0 0 0 8 11.232a2.864 2.864 0 0 0 2.857-2.707.143.143 0 0 0-.143-.15"
      />
    </g>
    <defs>
      <clipPath id="ai-agents-sidebar_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAiAgentsSidebar;
